import React, { useCallback } from 'react';

import formatPrice from 'Shared/util/formatPrice';
import Table from 'Components/Table';

const TableInvoiceDetail = ({ invoiceLines, currency }) => {
  const columns = [
    {
      cellProps: {
        Header: () => <span className="filter-title">SERVICE</span>,
        Cell: (props) => {
          return (
            <>
              <span className="rt-td__head">SERVICE</span>
              <div className={'rt-td__cell'}>
                <div className="invoice-detail-container">
                  <span className="invoice-detail title">{props.row.service.title}</span>
                  <span className="invoice-detail desc">{props.row.service.description}</span>
                </div>
              </div>
            </>
          );
        },
        accessor: 'service',
        sortable: false,
      },
    },
    {
      title: 'QTV',
      cellProps: {
        accessor: 'qtv',
        width: 108,
      },
    },
    {
      title: 'UNIT',
      cellProps: {
        accessor: 'unit',
        width: 100,
      },
    },
    {
      title: 'PRICE',
      cellProps: {
        accessor: 'price',
        width: 138,
      },
    },
    {
      title: 'AMOUNT',
      cellProps: {
        accessor: 'amount',
        width: 120,
      },
    },
  ];

  const mapInvoiceLinesDataToRows = useCallback(
    (invoiceLines = []) => {
      const filteredInvoices = invoiceLines.map(({ description, quantity, unitType, unitPrice, total, service }) => {
        return {
          qtv: {
            title: quantity ? quantity : '-',
          },
          unit: {
            title: unitType ? unitType : '-',
          },
          amount: {
            title: total ? `${formatPrice(total)} ${currency}` : '-',
          },
          price: {
            title: unitPrice ? `${formatPrice(unitPrice)} ${currency}` : '-',
          },
          service: {
            title: service ? service.title : '-',
            description: description ? description : '-',
          },
        };
      });

      return filteredInvoices;
    },
    [currency]
  );

  const tableSettings = {
    paginationHeight: 56,
    pageSize: window.innerWidth > 767 ? 10 : 3,
  };

  return (
    <div className="tab-invoice-lines" data-testid="tab_invoice_lines">
      {invoiceLines && (
        <div className="table-wrap">
          <Table
            key="input-filter"
            sortable={false}
            tableSettings={tableSettings}
            columns={columns}
            data={mapInvoiceLinesDataToRows(invoiceLines)}
          />
        </div>
      )}
    </div>
  );
};

export default TableInvoiceDetail;
